
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {OrderSide} from '../core/OrderSide';
import {FieldModelOrderSide} from '../core/OrderSide';

/**
 * OrderCancelPendingCreateMarketParams struct
 */
class OrderCancelPendingCreateMarketParams {
  /**
   * Initialize struct
   * @param {!number=} pendingOrderId
   * @param {string=} newClientOrderId
   * @param {number=} newAmount
   * @param {OrderSide=} newSide
   * @param {number=} newTakeProfit
   * @param {!boolean=} newTakeProfitReset
   * @param {number=} newStopLoss
   * @param {!boolean=} newStopLossReset
   * @param {string=} newComment
   * @param {number=} newMagic
   * @param {!boolean=} newMagicReset
   * @constructor
   */
  constructor (pendingOrderId = new UInt64(0, 0), newClientOrderId = null, newAmount = null, newSide = null, newTakeProfit = null, newTakeProfitReset = false, newStopLoss = null, newStopLossReset = false, newComment = null, newMagic = null, newMagicReset = false) {
    this.PendingOrderId = pendingOrderId
    this.NewClientOrderId = newClientOrderId
    this.NewAmount = newAmount
    this.NewSide = newSide
    this.NewTakeProfit = newTakeProfit
    this.NewTakeProfitReset = newTakeProfitReset
    this.NewStopLoss = newStopLoss
    this.NewStopLossReset = newStopLossReset
    this.NewComment = newComment
    this.NewMagic = newMagic
    this.NewMagicReset = newMagicReset
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderCancelPendingCreateMarketParams}
   * @param {!OrderCancelPendingCreateMarketParams} other Other struct
   * @returns {!OrderCancelPendingCreateMarketParams} This struct
   */
  copy (other) {
    if (other.PendingOrderId != null) {
      this.PendingOrderId = UInt64.fromNumber(other.PendingOrderId)
    } else {
      this.PendingOrderId = null
    }
    if (other.NewClientOrderId != null) {
      this.NewClientOrderId = other.NewClientOrderId
    } else {
      this.NewClientOrderId = null
    }
    if (other.NewAmount != null) {
      this.NewAmount = other.NewAmount
    } else {
      this.NewAmount = null
    }
    if (other.NewSide != null) {
      this.NewSide = OrderSide.fromObject(other.NewSide)
    } else {
      this.NewSide = null
    }
    if (other.NewTakeProfit != null) {
      this.NewTakeProfit = other.NewTakeProfit
    } else {
      this.NewTakeProfit = null
    }
    if (other.NewTakeProfitReset != null) {
      this.NewTakeProfitReset = other.NewTakeProfitReset
    } else {
      this.NewTakeProfitReset = null
    }
    if (other.NewStopLoss != null) {
      this.NewStopLoss = other.NewStopLoss
    } else {
      this.NewStopLoss = null
    }
    if (other.NewStopLossReset != null) {
      this.NewStopLossReset = other.NewStopLossReset
    } else {
      this.NewStopLossReset = null
    }
    if (other.NewComment != null) {
      this.NewComment = other.NewComment
    } else {
      this.NewComment = null
    }
    if (other.NewMagic != null) {
      this.NewMagic = other.NewMagic
    } else {
      this.NewMagic = null
    }
    if (other.NewMagicReset != null) {
      this.NewMagicReset = other.NewMagicReset
    } else {
      this.NewMagicReset = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderCancelPendingCreateMarketParams}
   * @returns {!OrderCancelPendingCreateMarketParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderCancelPendingCreateMarketParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderCancelPendingCreateMarketParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderCancelPendingCreateMarketParams}
   * @param {!OrderCancelPendingCreateMarketParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderCancelPendingCreateMarketParams)) {
      throw new TypeError('Instance of OrderCancelPendingCreateMarketParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderCancelPendingCreateMarketParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      PendingOrderId: ((this.PendingOrderId != null) ? this.PendingOrderId.toNumber() : null),
      NewClientOrderId: ((this.NewClientOrderId != null) ? this.NewClientOrderId : null),
      NewAmount: ((this.NewAmount != null) ? this.NewAmount : null),
      NewSide: ((this.NewSide != null) ? this.NewSide : null),
      NewTakeProfit: ((this.NewTakeProfit != null) ? this.NewTakeProfit : null),
      NewTakeProfitReset: ((this.NewTakeProfitReset != null) ? this.NewTakeProfitReset : null),
      NewStopLoss: ((this.NewStopLoss != null) ? this.NewStopLoss : null),
      NewStopLossReset: ((this.NewStopLossReset != null) ? this.NewStopLossReset : null),
      NewComment: ((this.NewComment != null) ? this.NewComment : null),
      NewMagic: ((this.NewMagic != null) ? this.NewMagic : null),
      NewMagicReset: ((this.NewMagicReset != null) ? this.NewMagicReset : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderCancelPendingCreateMarketParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderCancelPendingCreateMarketParams} other Object value
   * @returns {!OrderCancelPendingCreateMarketParams} Created struct
   */
  static fromObject (other) {
    return new OrderCancelPendingCreateMarketParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderCancelPendingCreateMarketParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderCancelPendingCreateMarketParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderCancelPendingCreateMarketParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 12049
  }
}

export { OrderCancelPendingCreateMarketParams };

/**
 * Fast Binary Encoding OrderCancelPendingCreateMarketParams field model
 */
class FieldModelOrderCancelPendingCreateMarketParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.PendingOrderId = new fbe.FieldModelUInt64(buffer, 4 + 4)
    this.NewClientOrderId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.PendingOrderId.fbeOffset + this.PendingOrderId.fbeSize), buffer, this.PendingOrderId.fbeOffset + this.PendingOrderId.fbeSize)
    this.NewAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewClientOrderId.fbeOffset + this.NewClientOrderId.fbeSize), buffer, this.NewClientOrderId.fbeOffset + this.NewClientOrderId.fbeSize)
    this.NewSide = new fbe.FieldModelOptional(new FieldModelOrderSide(buffer, this.NewAmount.fbeOffset + this.NewAmount.fbeSize), buffer, this.NewAmount.fbeOffset + this.NewAmount.fbeSize)
    this.NewTakeProfit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewSide.fbeOffset + this.NewSide.fbeSize), buffer, this.NewSide.fbeOffset + this.NewSide.fbeSize)
    this.NewTakeProfitReset = new fbe.FieldModelBool(buffer, this.NewTakeProfit.fbeOffset + this.NewTakeProfit.fbeSize)
    this.NewStopLoss = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewTakeProfitReset.fbeOffset + this.NewTakeProfitReset.fbeSize), buffer, this.NewTakeProfitReset.fbeOffset + this.NewTakeProfitReset.fbeSize)
    this.NewStopLossReset = new fbe.FieldModelBool(buffer, this.NewStopLoss.fbeOffset + this.NewStopLoss.fbeSize)
    this.NewComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewStopLossReset.fbeOffset + this.NewStopLossReset.fbeSize), buffer, this.NewStopLossReset.fbeOffset + this.NewStopLossReset.fbeSize)
    this.NewMagic = new fbe.FieldModelOptional(new fbe.FieldModelInt32(buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize), buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize)
    this.NewMagicReset = new fbe.FieldModelBool(buffer, this.NewMagic.fbeOffset + this.NewMagic.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.PendingOrderId.fbeSize + this.NewClientOrderId.fbeSize + this.NewAmount.fbeSize + this.NewSide.fbeSize + this.NewTakeProfit.fbeSize + this.NewTakeProfitReset.fbeSize + this.NewStopLoss.fbeSize + this.NewStopLossReset.fbeSize + this.NewComment.fbeSize + this.NewMagic.fbeSize + this.NewMagicReset.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.PendingOrderId.fbeExtra + this.NewClientOrderId.fbeExtra + this.NewAmount.fbeExtra + this.NewSide.fbeExtra + this.NewTakeProfit.fbeExtra + this.NewTakeProfitReset.fbeExtra + this.NewStopLoss.fbeExtra + this.NewStopLossReset.fbeExtra + this.NewComment.fbeExtra + this.NewMagic.fbeExtra + this.NewMagicReset.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderCancelPendingCreateMarketParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 12049
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.PendingOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PendingOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PendingOrderId.fbeSize

    if ((fbeCurrentSize + this.NewClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAmount.fbeSize

    if ((fbeCurrentSize + this.NewSide.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSide.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSide.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTakeProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfit.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfitReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTakeProfitReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.NewStopLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewStopLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLoss.fbeSize

    if ((fbeCurrentSize + this.NewStopLossReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewStopLossReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLossReset.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewMagic.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMagic.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagic.fbeSize

    if ((fbeCurrentSize + this.NewMagicReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMagicReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagicReset.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!OrderCancelPendingCreateMarketParams} fbeValue Default value, defaults is new OrderCancelPendingCreateMarketParams()
   * @returns {!OrderCancelPendingCreateMarketParams} OrderCancelPendingCreateMarketParams value
   */
  get (fbeValue = new OrderCancelPendingCreateMarketParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!OrderCancelPendingCreateMarketParams} fbeValue OrderCancelPendingCreateMarketParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.PendingOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.PendingOrderId = this.PendingOrderId.get()
    } else {
      fbeValue.PendingOrderId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PendingOrderId.fbeSize

    if ((fbeCurrentSize + this.NewClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.NewClientOrderId = this.NewClientOrderId.get()
    } else {
      fbeValue.NewClientOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewAmount.fbeSize) <= fbeStructSize) {
      fbeValue.NewAmount = this.NewAmount.get()
    } else {
      fbeValue.NewAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAmount.fbeSize

    if ((fbeCurrentSize + this.NewSide.fbeSize) <= fbeStructSize) {
      fbeValue.NewSide = this.NewSide.get()
    } else {
      fbeValue.NewSide = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSide.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfit.fbeSize) <= fbeStructSize) {
      fbeValue.NewTakeProfit = this.NewTakeProfit.get()
    } else {
      fbeValue.NewTakeProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfit.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfitReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewTakeProfitReset = this.NewTakeProfitReset.get()
    } else {
      fbeValue.NewTakeProfitReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.NewStopLoss.fbeSize) <= fbeStructSize) {
      fbeValue.NewStopLoss = this.NewStopLoss.get()
    } else {
      fbeValue.NewStopLoss = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLoss.fbeSize

    if ((fbeCurrentSize + this.NewStopLossReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewStopLossReset = this.NewStopLossReset.get()
    } else {
      fbeValue.NewStopLossReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLossReset.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) <= fbeStructSize) {
      fbeValue.NewComment = this.NewComment.get()
    } else {
      fbeValue.NewComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewMagic.fbeSize) <= fbeStructSize) {
      fbeValue.NewMagic = this.NewMagic.get()
    } else {
      fbeValue.NewMagic = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagic.fbeSize

    if ((fbeCurrentSize + this.NewMagicReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewMagicReset = this.NewMagicReset.get()
    } else {
      fbeValue.NewMagicReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagicReset.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {!OrderCancelPendingCreateMarketParams} fbeValue OrderCancelPendingCreateMarketParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderCancelPendingCreateMarketParams}
   * @param {OrderCancelPendingCreateMarketParams} fbeValue OrderCancelPendingCreateMarketParams value
   */
  setFields (fbeValue) {
    this.PendingOrderId.set(fbeValue.PendingOrderId)
    this.NewClientOrderId.set(fbeValue.NewClientOrderId)
    this.NewAmount.set(fbeValue.NewAmount)
    this.NewSide.set(fbeValue.NewSide)
    this.NewTakeProfit.set(fbeValue.NewTakeProfit)
    this.NewTakeProfitReset.set(fbeValue.NewTakeProfitReset)
    this.NewStopLoss.set(fbeValue.NewStopLoss)
    this.NewStopLossReset.set(fbeValue.NewStopLossReset)
    this.NewComment.set(fbeValue.NewComment)
    this.NewMagic.set(fbeValue.NewMagic)
    this.NewMagicReset.set(fbeValue.NewMagicReset)
  }
}

export { FieldModelOrderCancelPendingCreateMarketParams };

/**
 * Fast Binary Encoding OrderCancelPendingCreateMarketParams model
 */
class OrderCancelPendingCreateMarketParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderCancelPendingCreateMarketParams(this.buffer, 4)
  }

  /**
   * Get the OrderCancelPendingCreateMarketParams model
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!FieldModelOrderCancelPendingCreateMarketParams} model OrderCancelPendingCreateMarketParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderCancelPendingCreateMarketParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderCancelPendingCreateMarketParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @param {!OrderCancelPendingCreateMarketParams} value OrderCancelPendingCreateMarketParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @param {!OrderCancelPendingCreateMarketParams} value OrderCancelPendingCreateMarketParams value, defaults is new OrderCancelPendingCreateMarketParams()
   * @return {!object} Deserialized OrderCancelPendingCreateMarketParams value and its size
   */
  deserialize (value = new OrderCancelPendingCreateMarketParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderCancelPendingCreateMarketParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderCancelPendingCreateMarketParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderCancelPendingCreateMarketParamsModel}
   * @param {!number} prev Previous OrderCancelPendingCreateMarketParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderCancelPendingCreateMarketParamsModel };
